export const hasNoSpecialCharacters = (string: string): boolean => {
  // Regular expression to match any special character (non-alphanumeric)
  const specialCharRegex = /[^a-zA-Z0-9]/g;

  // Test if the string contains any special characters
  return !specialCharRegex.test(string);
};

export const hasNumbersOnlyInString = (location?: string | null): boolean => {
  if (!location) {
    return false;
  }
  return /^\d+$/.test(location);
};
